import { ClientError } from "graphql-request";
import { datadogRum } from "@datadog/browser-rum";
import { LOCKED_STATUS_CODE } from "src/components/admin/Settings/consts";

export const normalizeGraphQLError = (error) => {
  if (!(error instanceof ClientError)) {
    datadogRum.addError(error);
    throw error;
  }

  const status = error.response?.status ?? 0;
  const firstGqlMessage = error.response?.errors?.[0]?.message;
  const message = firstGqlMessage || error.message;

  const normalized = new Error(message);
  normalized.name = "GraphQLError";
  normalized.response = {
    status,
    data: error.response,
    errors: error.response?.errors
  };
  normalized.code = status >= 500 ? "ERR_SERVER" : "ERR_BAD_REQUEST";
  normalized.cause = error;

  datadogRum.addError(normalized);

  if (status === LOCKED_STATUS_CODE) {
    setTimeout(() => window.location.reload(), 1000);
  }

  throw normalized;
};
